import { render, staticRenderFns } from "./baogao.vue?vue&type=template&id=a16da62c&scoped=true"
import script from "./baogao.vue?vue&type=script&lang=js"
export * from "./baogao.vue?vue&type=script&lang=js"
import style0 from "./baogao.vue?vue&type=style&index=0&id=a16da62c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a16da62c",
  null
  
)

export default component.exports